class SearchTabButtons extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.search-page');
    this.tabButtons = this.querySelectorAll('.search-tab-button');
    this.resultContainers = this.parent.querySelectorAll('.search_result_tab_wrapper');
    this.filters = this.parent?.querySelector('.collection__sidebar__slider');
    this.searchResultCounts = this.parent.querySelectorAll('.search-result__item-count');
    this.collectionNav = this.parent?.querySelector('.collection__nav ');
    this.mobileFilters = this.parent?.querySelector('.collection__active__filters--wrapper-mobile');
    this.collectionProducts = this.parent?.querySelector('.collection__products');
    this.gridOuter = this.parent?.querySelector('.grid-outer');
  }

  connectedCallback() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const currentButton = event.currentTarget;
        this.tabButtons.forEach((btn) => btn.classList.remove('active'));

        currentButton.classList.add('active');
        const currentButtonAttribute = currentButton.getAttribute('data-tab-label');

        if (currentButtonAttribute === 'product') {
          if (this.filters) this.filters.style.display = 'flex';
          this.gridOuter.classList.remove('grid-outer--not-product');
          if (window.innerWidth <= 1024) {
            if (this.collectionNav) this.collectionNav.style.display = 'flex';
            if (this.mobileFilters) this.mobileFilters.style.marginTop = '18px';
            if (this.collectionProducts) this.collectionProducts.style.marginTop = '24px';
          }
        } else if (currentButtonAttribute === 'article') {
          if (this.filters) this.filters.style.display = 'none';
          this.gridOuter.classList.add('grid-outer--not-product');
          if (window.innerWidth <= 1024) {
            if (this.collectionNav) this.collectionNav.style.display = 'none';
            if (this.mobileFilters) this.mobileFilters.style.marginTop = '0';
            if (this.collectionProducts) this.collectionProducts.style.marginTop = '24px';
          }
        } else {
          if (this.filters) this.filters.style.display = 'none';
          this.gridOuter.classList.add('grid-outer--not-product');
          if (window.innerWidth <= 1024) {
            if (this.collectionNav) this.collectionNav.style.display = 'none';
            if (this.mobileFilters) this.mobileFilters.style.marginTop = '0';
            if (this.collectionProducts) this.collectionProducts.style.marginTop = '36px';
          }
        }

        this.resultContainers.forEach((container) => container.classList.remove('active'));
        this.resultContainers.forEach((item) => {
          if (item.classList.contains(`wrapper--${currentButtonAttribute}`)) {
            item.classList.add('active');
          }
        });

        this.searchResultCounts.forEach((resultCount) => resultCount.classList.remove('active'));
        this.searchResultCounts.forEach((resultItem) => {
          if (resultItem.classList.contains(`item-count--${currentButtonAttribute}`)) {
            resultItem.classList.add('active');
          }
        });
      });
    });
  }
}

if (!customElements.get('search-tab-buttons')) {
  customElements.define('search-tab-buttons', SearchTabButtons);
}